import React from "react";
import DashboardCard from "../../components/dashboard/DashboardCard";
import TimesheetChart from "../../components/dashboard/TimesheetGraph";
import { RecentProjects } from "../../components/dashboard/RecentProjects";
import { MyTasks } from "../../components/dashboard/MyTasks";
import IssueDynamicTable from "../../components/dashboard/MyIssues";
import { OverdueComponent } from "../../components/dashboard/MyOverDues";
import { useNavigate } from "react-router-dom";
import TodaysTask from "../../components/dashboard/TodaysTask";

const Dashboard = () => {
  const navigate = useNavigate();

  const data = {
    activeProjects: 25,
    openTasks: 10,
    openIssues: 5,
    milestones: 15,
  };

  const projects = [
    { id: 1, name: "Techno Tackle", owner: "Bala Krishnan", progress: 45 },
    { id: 2, name: "Compass Tex", owner: "Suresh", progress: 85 },
    {
      id: 3,
      name: "GPLG-PM & Client tools",
      owner: "Jai Prathiban",
      progress: 50,
    },
  ];

  const projects_task = [
    {
      id: 1,
      name: "Techno Tackle",
      owner: "Bala Krishnan",
      progress: 45,
      tasks: [
        {
          id: 101,
          name: "Optimise technotackle portfolio site to reduce loading...",
        },
        // { id: 102, name: 'Task 2 - API Integration' },
      ],
    },
    {
      id: 2,
      name: "Compass Tex",
      owner: "Suresh",
      progress: 85,
      tasks: [
        { id: 201, name: "TPrototype on Mobile UI" },
        // { id: 202, name: 'Task 2 - Design' },
      ],
    },
    {
      id: 3,
      name: "GPLG-PM & Client tools",
      owner: "Jai Prathiban",
      progress: 50,
      tasks: [
        { id: 301, name: "Project and Task UI" },
        // { id: 302, name: 'Task 2 - Implementation' },
      ],
    },
  ];

  const overdueTasks = [
    {
      task: "Dashboard UI Design",
      project: "Techno Tackle",
      dueDate: "2023-10-30",
    },
    {
      task: "API Integration",
      project: "Techno Tackle",
      dueDate: "2023-10-28",
    },
    { task: "UI Testing", project: "Techno Tackle", dueDate: "2023-10-29" },
  ];

  const events = [
    {
      eventName: "Diwali Celebration",
      time: "02:00 PM - 06:00 AM",
      date: "2024-10-26",
    },
    { eventName: "Meet Out", time: "02:00 PM - 06:00 AM", date: "2022-11-15" },
  ];

  const handleTaskSeeMore = () => {
    navigate("/tasks");
  };

  const handleProjectSeeMore = () => {
    navigate("/projects");
  };

  const handelTimeSheetSeeMore = () => {
    navigate("/timesheet");
  };

  const handelIssueSeeMore = () => {
    navigate("/issues");
  };

  return (
    <div className="container-fluid pb-4">
      <div className="row">
        <div className="col-md-6 mb-3">
          <DashboardCard data={data} />
        </div>
        <div className="col-md-6 mb-3">
          <TimesheetChart onSeeMore={handelTimeSheetSeeMore} />
        </div>
        <div className="col-md-12 col-12">
          <TodaysTask />
        </div>
        <div className="col-md-6 my-2">
          <RecentProjects
            projects={projects}
            onSeeMore={handleProjectSeeMore}
          />
        </div>
        <div className="col-md-6 my-2">
          <MyTasks
            projects_task={projects_task}
            onSeeMore={handleTaskSeeMore}
          />
        </div>
        <div className="col-md-12 my-2">
          <IssueDynamicTable onSeeMore={handelIssueSeeMore} />
        </div>
        <div className="col-md-12 my-2">
          <OverdueComponent overdueTasks={overdueTasks} />
        </div>
        {/* <div className="col-md-6 my-2">
          <UpcomingEvents events={events} />
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;
